/**
 * AfriMeet Logo — image-based (uses uploaded PNG with transparent background)
 */

function LogoSVG({ size = 56 }) {
  return (
    <img
      src="/afrimeet-logo.png"
      alt="AfriMeet"
      width={size}
      height={size}
      className="drop-shadow-[0_2px_6px_rgba(184,134,45,0.3)] object-contain"
      style={{ width: size, height: size }}
    />
  );
}

// Keep the URL export for any legacy reference (e.g. favicon meta)
export const LOGO_URL = "/afrimeet-logo.png";

import { useLang } from "@/i18n";

export default function Logo({ size = 56, withWordmark = false, tagline = false, className = "" }) {
  const { t } = useLang();
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className="shrink-0 flex items-center justify-center"
        style={{ width: size, height: size }}
      >
        <LogoSVG size={size} />
      </div>
      {withWordmark && (
        <div className="leading-tight">
          <div
            className="font-display font-extrabold tracking-tight text-af"
            style={{ fontSize: size * 0.46 }}
          >
            AfriMeet
          </div>
          {tagline && (
            <div
              className="tracking-[0.22em] text-af-muted font-bold uppercase mt-1.5"
              style={{ fontSize: size * 0.14 }}
            >
              {t.brand?.tagline || "Enregistre. Transcrit. Résume."}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
